/* =============================================================================
 * CUSTOM COLLECTION — shared runtime
 *
 * Initialises every [data-cs-card-group] on the page (regardless of which
 * section it lives in) by:
 *
 *   1. Wiring up per-card variant radios + "View product" links
 *      (no-ops on cards that don't have variant inputs, so it's safe to run
 *       on the bundle/card-row cards too).
 *   2. Booting the slick carousel with the project's fractional slidesToShow
 *      breakpoints, falling back to a static flex layout when the row fits
 *      without a carousel.
 *   3. Suppressing accidental clicks on drag and enabling smooth wheel/swipe
 *      scrolling.
 *
 * Loaded by:
 *   - sections/custom-collection-products.liquid
 *   - sections/custom-card-row.liquid
 * ============================================================================= */

(function () {
  function init(root) {
    var scope = root || document;
    var groups = scope.querySelectorAll('[data-cs-card-group]');
    if (!groups.length) return;

    Array.prototype.forEach.call(groups, function (group) {
      if (group.dataset.csInit === '1') return;
      group.dataset.csInit = '1';

      setupCards(group);
      initSlick(group);
    });
  }

  function setupCards(group) {
    var cards = group.querySelectorAll('[data-cs-card]');
    Array.prototype.forEach.call(cards, function (card) {
      setupCard(card);
    });
  }

  function setupCard(card) {
    var idInput = card.querySelector('[data-variant-id]');
    var viewProductLink = card.querySelector('[data-cs-view-product]');
    var cardLink = card.querySelector('.cs-card-link');
    var titleLink = card.querySelector('[data-cs-title-link]');
    var labels = card.querySelectorAll('[data-cs-size]');

    labels.forEach(function (label) {
      var radio = label.querySelector('input[type="radio"]');
      if (!radio) return;
      if (radio.checked) label.classList.add('is-selected');

      radio.addEventListener('change', function () {
        labels.forEach(function (l) { l.classList.remove('is-selected'); });
        label.classList.add('is-selected');
        var variantId = radio.value;
        if (idInput) idInput.value = variantId;

        updateProductLinks(viewProductLink, cardLink, titleLink, variantId);
      });
    });

    // Prevent the whole-card link from firing when interacting with the controls inside `.cs-product-actions`.
    var actionsContainer = card.querySelector('.cs-product-actions');
    if (actionsContainer) {
      actionsContainer.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    var checkedRadio = card.querySelector('[data-cs-size] input[type="radio"]:checked');
    if (checkedRadio) {
      updateProductLinks(viewProductLink, cardLink, titleLink, checkedRadio.value);
    } else if (idInput) {
      updateProductLinks(viewProductLink, cardLink, titleLink, idInput.value);
    }
  }

  function updateProductLinks(viewProductLink, cardLink, titleLink, variantId) {
    if (viewProductLink) {
      var baseUrl = viewProductLink.getAttribute('data-product-url');
      if (baseUrl) viewProductLink.href = baseUrl + '?variant=' + variantId;
    }
    if (cardLink && cardLink.href) {
      var currentHref = cardLink.href;
      var splitBase = currentHref.split('?')[0];
      cardLink.href = splitBase + '?variant=' + variantId;
    }
    if (titleLink) {
      var titleBase = titleLink.getAttribute('data-product-url');
      if (titleBase) titleLink.href = titleBase + '?variant=' + variantId;
    }
  }

  function initSlick(group) {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn || !window.jQuery.fn.slick) {
      return setTimeout(function () { initSlick(group); }, 60);
    }
    var $group = window.jQuery(group);
    if ($group.hasClass('slick-initialized')) return;

    // Slick with `slidesToShow` greater than the number of slides (and `infinite: false`)
    // collapses each card to a sliver; if the group fits the desktop grid without a
    // carousel, skip slick entirely and keep the native flex layout (which also
    // supports horizontal scroll on mobile).
    var cardCount = group.querySelectorAll(':scope > .cs-card').length;
    var DESKTOP_SLIDES = 4;
    if (cardCount === 0 || cardCount <= DESKTOP_SLIDES) {
      group.classList.add('cs-card-group--static');
      return;
    }

    $group.slick({
      infinite: false,
      slidesToShow: 4.15,
      slidesToScroll: 1,
      swipeToSlide: true,
      touchThreshold: 12,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev cs-slick__arrow cs-slick__arrow--prev" aria-label="Previous"><span aria-hidden="true">&#8249;</span></button>',
      nextArrow: '<button type="button" class="slick-next cs-slick__arrow cs-slick__arrow--next" aria-label="Next"><span aria-hidden="true">&#8250;</span></button>',
      responsive: [
        { breakpoint: 1400, settings: { slidesToShow: 3.15, arrows: true, swipeToSlide: true, touchThreshold: 12 } },
        { breakpoint: 1100, settings: { slidesToShow: 2.4, arrows: false, swipeToSlide: true, touchThreshold: 12 } },
        { breakpoint: 800,  settings: { slidesToShow: 1.8, arrows: false, swipeToSlide: true, touchThreshold: 12 } },
        { breakpoint: 600,  settings: { slidesToShow: 1.4, arrows: false, swipeToSlide: true, touchThreshold: 12 } }
      ]
    });

    suppressClickAfterDrag($group);
    enableWheelSwipe($group);
  }

  // Prevent accidental navigation when the user drags on links/cards inside the carousel.
  function suppressClickAfterDrag($group) {
    var dragged = false;
    var startX = 0;
    var startY = 0;
    var THRESHOLD = 6;

    function markStart(x, y) {
      dragged = false;
      startX = x;
      startY = y;
    }
    function markMove(x, y) {
      if (Math.abs(x - startX) > THRESHOLD || Math.abs(y - startY) > THRESHOLD) {
        dragged = true;
      }
    }

    $group.on('mousedown.csDrag', function (e) { markStart(e.clientX, e.clientY); });
    $group.on('mousemove.csDrag', function (e) { if (e.buttons) markMove(e.clientX, e.clientY); });
    $group.on('touchstart.csDrag', function (e) {
      var t = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
      if (t) markStart(t.clientX, t.clientY);
    });
    $group.on('touchmove.csDrag', function (e) {
      var t = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
      if (t) markMove(t.clientX, t.clientY);
    });

    $group[0].addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
        dragged = false;
      }
    }, true);
  }

  // Allow trackpad/mouse-wheel horizontal movement with smooth drag-like scrolling.
  function enableWheelSwipe($group) {
    if (!$group || !$group.length) return;

    var groupEl = $group[0];
    var slickList = groupEl.querySelector('.slick-list');
    var slickTrack = groupEl.querySelector('.slick-track');
    if (!slickList || !slickTrack) return;

    var isWheelScrolling = false;
    var wheelEndTimeout = null;
    var currentOffset = 0;
    var velocity = 0;
    var momentumFrame = null;

    function getTrackOffset() {
      var transform = slickTrack.style.transform;
      var match = transform.match(/translate3d\((-?[\d.]+)px/);
      return match ? parseFloat(match[1]) : 0;
    }

    function getMaxOffset() {
      var trackWidth = slickTrack.scrollWidth;
      var listWidth = slickList.offsetWidth;
      return Math.min(0, listWidth - trackWidth);
    }

    function setTrackOffset(offset) {
      var maxOffset = getMaxOffset();
      var clampedOffset = Math.max(maxOffset, Math.min(0, offset));
      slickTrack.style.transform = 'translate3d(' + clampedOffset + 'px, 0px, 0px)';
      return clampedOffset;
    }

    function applyMomentum() {
      if (Math.abs(velocity) < 0.5) {
        syncSlickPosition();
        return;
      }
      velocity *= 0.95;
      currentOffset = setTrackOffset(currentOffset + velocity);
      momentumFrame = requestAnimationFrame(applyMomentum);
    }

    function syncSlickPosition() {
      var slick = $group.slick('getSlick');
      if (!slick) return;

      var offset = Math.abs(getTrackOffset());
      var slides = slick.$slides.toArray();
      var accumulated = 0;
      var targetSlide = 0;

      for (var i = 0; i < slides.length; i++) {
        var slideWidth = slides[i].offsetWidth;
        if (accumulated + slideWidth / 2 > offset) {
          targetSlide = i;
          break;
        }
        accumulated += slideWidth;
        targetSlide = i;
      }

      $group.slick('slickGoTo', targetSlide, true);
    }

    slickList.addEventListener('wheel', function (event) {
      var deltaX = event.deltaX || 0;
      var deltaY = event.deltaY || 0;

      if (Math.abs(deltaX) < Math.abs(deltaY) && !event.shiftKey) return;

      var horizontalDelta = event.shiftKey ? deltaY : deltaX;
      if (Math.abs(horizontalDelta) < 1) return;

      event.preventDefault();

      if (momentumFrame) {
        cancelAnimationFrame(momentumFrame);
        momentumFrame = null;
      }

      if (!isWheelScrolling) {
        isWheelScrolling = true;
        currentOffset = getTrackOffset();
      }

      velocity = -horizontalDelta * 0.8;
      currentOffset = setTrackOffset(currentOffset - horizontalDelta);

      clearTimeout(wheelEndTimeout);
      wheelEndTimeout = setTimeout(function () {
        isWheelScrolling = false;
        momentumFrame = requestAnimationFrame(applyMomentum);
      }, 100);
    }, { passive: false });
  }

  function bootInitial() {
    init(document);
  }

  if (document.readyState !== 'loading') {
    bootInitial();
  } else {
    document.addEventListener('DOMContentLoaded', bootInitial);
  }

  // Re-init when a host section is reloaded by the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target || document.getElementById('shopify-section-' + (e.detail && e.detail.sectionId));
    init(sectionEl || document);
  });
})();
